import { titleCase } from "@/workspace/humanize"
import type { AreaMeta, Ontology } from "@/workspace/ontology"

/**
 * Every object type, by area: the Business areas first, then one group per remaining namespace
 * (Core types no tenant type links to, such as connector-mapped `party.Customer`), so the analyst
 * view never hides a type that holds records.
 */
export function dataAreas(ontology: Ontology): AreaMeta[] {
  const listed = new Set(ontology.areas.flatMap((a) => a.types))
  const rest = new Map<string, string[]>()
  for (const t of ontology.types.values()) {
    if (listed.has(t.name)) continue
    const group = rest.get(t.namespace) ?? []
    group.push(t.name)
    rest.set(t.namespace, group)
  }
  // A Core area lists only linked types; its namespace's other types join it rather than a second, same-id group.
  const merged = ontology.areas.map((area) => {
    const more = rest.get(area.id)
    rest.delete(area.id)
    return more ? { ...area, types: [...area.types, ...more] } : area
  })
  const extra = [...rest.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([id, types]): AreaMeta => ({ id, label: titleCase(id.replace(/\./g, " ")), types, core: types.every((n) => ontology.types.get(n)?.layer !== "tenant"), apps: [] }))
  return [...merged, ...extra]
}

export function dataAreaOf(areas: readonly AreaMeta[], typeName: string): AreaMeta | undefined {
  return areas.find((a) => a.types.includes(typeName))
}
